export default "__VITE_ASSET__D102qwJY__"